import { render, staticRenderFns } from "./tile.vue?vue&type=template&id=496ef660&scoped=true&lang=pug"
import script from "./tile.vue?vue&type=script&lang=ts"
export * from "./tile.vue?vue&type=script&lang=ts"
import style0 from "./tile.vue?vue&type=style&index=0&id=496ef660&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496ef660",
  null
  
)

/* custom blocks */
import block0 from "@locales/de/de.yml?namespace=ui.views.users.show.types?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuild%2Ffrontend%2Fcomponents%2Fusers%2Ftile.vue&locale=de&lang=yaml&external"
if (typeof block0 === 'function') block0(component)
import block1 from "@locales/en/en.yml?namespace=ui.views.users.show.types?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fbuild%2Ffrontend%2Fcomponents%2Fusers%2Ftile.vue&locale=en&lang=yaml&external"
if (typeof block1 === 'function') block1(component)
import block2 from "@locales/de/de.yml?namespace=ui.components.users.tile?vue&type=custom&index=2&blockType=i18n&issuerPath=%2Fbuild%2Ffrontend%2Fcomponents%2Fusers%2Ftile.vue&locale=de&lang=yaml&external"
if (typeof block2 === 'function') block2(component)
import block3 from "@locales/en/en.yml?namespace=ui.components.users.tile?vue&type=custom&index=3&blockType=i18n&issuerPath=%2Fbuild%2Ffrontend%2Fcomponents%2Fusers%2Ftile.vue&locale=en&lang=yaml&external"
if (typeof block3 === 'function') block3(component)
import block4 from "@locales/de/de.yml?namespace=ui.shared.users.advisor_classification?vue&type=custom&index=4&blockType=i18n&issuerPath=%2Fbuild%2Ffrontend%2Fcomponents%2Fusers%2Ftile.vue&locale=de&lang=yaml&external"
if (typeof block4 === 'function') block4(component)
import block5 from "@locales/en/en.yml?namespace=ui.shared.users.advisor_classification?vue&type=custom&index=5&blockType=i18n&issuerPath=%2Fbuild%2Ffrontend%2Fcomponents%2Fusers%2Ftile.vue&locale=en&lang=yaml&external"
if (typeof block5 === 'function') block5(component)

export default component.exports